import { render, staticRenderFns } from "./PriorityRule.vue?vue&type=template&id=18c32891&scoped=true&"
import script from "./PriorityRule.vue?vue&type=script&lang=js&"
export * from "./PriorityRule.vue?vue&type=script&lang=js&"
import style0 from "./PriorityRule.vue?vue&type=style&index=0&id=18c32891&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c32891",
  null
  
)

export default component.exports